import React, { useEffect, useState } from "react";
import styles from "./version-string-info-nav.module.scss";
import {
  ToolTip,
  ToolTipPositionType,
} from "@src/components/atoms/tooltip/tooltip";
import { TextButton } from "../buttons/text-button/text-button";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { getVersionStringBuilder } from "@src/cloud-connect/dependency-injection-container/get-version-string-builder";
import { useI18N } from "@src/language/language-context";

interface VersionStringInfoNavProps {
  tooltipPosition: ToolTipPositionType;
}

const cssClassName = "version-string-info-nav";

export const VersionStringInfoNav = ({
  tooltipPosition,
}: VersionStringInfoNavProps) => {
  const i18n = useI18N();
  const [versionString, setVersionString] = useState("");

  const texts = {
    linkText: i18n("modules.versionStringInfo.linkText"),
    copySuccessText: i18n("modules.versionStringInfo.copySuccessText"),
    copyErrorText: i18n("modules.versionStringInfo.copyErrorText"),
    toolTipText: i18n("modules.versionStringInfo.toolTipText"),
  };

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      successSnackbar(texts.copySuccessText);
    } catch (err) {
      console.error(`${texts.copyErrorText}: `, err);
      errorSnackbar(`${texts.copyErrorText}: ${err}`, 5000);
    }
  };

  const handleClick = () => {
    copyToClipboard(versionString);
  };

  useEffect(() => {
    setVersionString(getVersionStringBuilder().build());
  }, []);

  return (
    <div className={styles[cssClassName]}>
      {versionString && (
        <ToolTip content={texts.toolTipText} position={tooltipPosition}>
          <span
            className={styles[`${cssClassName}__link-text`]}
          >{`${texts.linkText}`}</span>
          <br />
          <TextButton clickHandler={handleClick} text={versionString} />
        </ToolTip>
      )}
    </div>
  );
};
